import React, { FC } from 'react';
import styles from './modal_confirmation_header.module.scss';
import { MaterialIcon } from '../../../material-icon/MaterialIcon';

type Props = {
  title: string | React.ReactNode;
  onClose: () => void;
};

export const ModalConfirmationHeader: FC<Props> = ({ title, onClose }) => (
  <>
    <div className={styles.close} onClick={onClose}>
      <MaterialIcon name="close" className={styles.icon} />
    </div>
    <div className={styles.title}>{title}</div>
  </>
);
